export default "/assets/images/spring-background.webp?dc71400a389e3c85e6bc3b32b3a56b89";